import React from "react";
import { useEffect, useState } from 'react';
import { formatDate } from 'utils/FormatDate.js';
import InfiniteScroll from "react-infinite-scroll-component";
import {
    Form,
    Card,
    Col,
    Button,
    OverlayTrigger,
    Row,
    Table,
    Tooltip, Spinner
} from "react-bootstrap";


function AuditLog(props) {
    // Render Audit Table
    const renderAuditTable = () => {
        if (props.auditLogs.length > 0) {
            {
                return (
                    <Table className="table-hover table-striped w-full" style={{ overflow: "scroll" }}>
                        <thead>
                            <tr>
                                <th>Timestamp</th>
                                <th>Username</th>
                                <th>Type Name</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.auditLogs.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{formatDate(item.timestamp)}</td>
                                        <td>{item.username}</td>
                                        <td>{item.typeName}</td>
                                        <td>{item.description}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                )
            }
        }
    }

    return (
        <Card.Body className="table-responsive p-0 item-card-tab">
            {props.isLoading ?
                <div style={{ height: 550 }} className="d-flex justify-content-center align-items-center text-center">
                    <div>
                        <Spinner animation="border" />
                        <p>Loading...</p>
                    </div>
                </div> :
                <>
                    {(props.auditLogs && props.auditLogs.length == 0) &&
                        (<p
                            style={{ height: 550 }}
                            className="d-flex justify-content-center align-items-center text-center"
                        >
                            No data found.
                        </p>)}
                </>
            }
            {props.auditLogs && props.auditLogs.length > 0 && !props.isLoading && (
                <Col md="12">
                    <InfiniteScroll
                        dataLength={props.auditLogs.length}
                        next={props.updateAuditLogs}
                        hasMore={props.auditLogs.length >= props.page * props.take}
                        loader={<h6>Loading more data...</h6>}
                        height={670}
                    >
                        {renderAuditTable()}
                    </InfiniteScroll>
                </Col>)}
        </Card.Body>
    );
}
export default AuditLog;
